<template>
  <div class="ScienceCatalog">
    <science-sidebar></science-sidebar>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Science/science_catalog.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <h2 id="candidate-heading">CHIME/FRB Internal Catalog V1 </h2>
    <div class="text-center" id="welcome"> Hello </div>
    <b-row>
    <b-col md="3">
    </b-col>
    <b-col md="6">
    <vueper-slides
      lazy lazy-load-on-drag
      class="no-shadow"
      :visible-slides="2"
      slide-multiple
      :slide-ratio="1 / 1"
      :gap="3"
      fixed-height="450px"
      :dragging-distance="70">
      <vueper-slide v-for="(slide, i) in slides" :key="i" :image="slide.image" :link="slide.image">
      <template v-slot:loader>
        <b-spinner
            v-for="variant in variants.slice(2, 3)"
              :variant="variant"
              :key="variant"
          ></b-spinner>
      </template>
    </vueper-slide>
    </vueper-slides>
    </b-col>
    <b-col md="3">
    </b-col>
    </b-row>
    <b-container fluid>
      <b-row>
        <b-col md="4">
        </b-col>
        <b-col md="4" class="my-1">
          <a class="download-button"
            :href="downloadData"
            :download="catalogName">
            <b-button variant="dark">
              Download Catalog
            </b-button>
          </a>
        </b-col>
        <b-col md="4">
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2">
        </b-col>
        <b-col md="4" class="my-1">
          <h3>Table 1</h3>
        </b-col>
        <b-col md="2">
        </b-col>
        <b-col md="1">
        </b-col>
        <b-col md="2" class="my-1">
          <h3>Name Map</h3>
        </b-col>
        <b-col md="1">
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2" class="my-1">
          <b-form-group horizontal label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter1" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions1" v-model="perPage1" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-pagination
      v-model="currentPage1"
      :total-rows="totalRows1"
      :per-page="perPage1"
      aria-controls="table1"
    ></b-pagination>
        </b-col>
        <b-col md="2" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions3" v-model="perPage3" />
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1">
          <b-pagination :total-rows="totalRows3" :per-page="perPage3" v-model="currentPage3" class="my-0" />
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-row>
        <b-col md="8" v-if="items1.length != 0">
        <b-table show-empty
               id="table1"
               :items="items1"
               :fields="fields1"
               :small="smallTable"
               :current-page="currentPage1"
               :per-page="perPage1"
               :filter="filter1"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               :head-variant="headVariant"
               :table-variant="tableVariant"
               @filtered="onFiltered1"
        >
        </b-table>
        </b-col>
        <b-col md="8" v-else>
          <b-spinner
            v-for="variant in variants.slice(0, 5)"
              :variant="variant"
              :key="variant"
          ></b-spinner>
        </b-col>
        <b-col md="4" v-if="items3.length != 0">
        <b-table show-empty
               :items="items3"
               :fields="fields3"
               :small="smallTable"
               :current-page="currentPage3"
               :per-page="perPage3"
               :filter="filter3"
               :dark=false
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               :head-variant="headVariant"
               :table-variant="tableVariant"
               @filtered="onFiltered3"
        >
        </b-table>
        </b-col>
        <b-col md="4" v-else>
          <b-spinner
            v-for="variant in variants.slice(0,3)"
              :variant="variant"
              :key="variant"
          ></b-spinner>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
        </b-col>
        <b-col md="4" class="my-1">
          <h3>Burst Properties</h3>
        </b-col>
        <b-col md="4">
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter2" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions2" v-model="perPage2" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-pagination :total-rows="totalRows2" :per-page="perPage2" v-model="currentPage2" class="my-0" />
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-row>
        <b-col md="12" v-if="items2.length != 0">
        <b-table show-empty
               :items="items2"
               :fields="fields2"
               :small="smallTable"
               :dark=false
               :current-page="currentPage2"
               :per-page="perPage2"
               :filter="filter2"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               :head-variant="headVariant"
               :table-variant="tableVariant"
               @filtered="onFiltered2"
        >
        </b-table>
        </b-col>
        <b-col md="8" v-else>
          <b-spinner
            v-for="variant in variants"
              :variant="variant"
              :key="variant"
          ></b-spinner>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style type="text/css">
.ex--center-mode {
  width: 900px;
  max-width: 100%;
  margin: auto;
}
</style>
<script>
import { AnalysisMixin } from '../mixins/analysisMixin.js'
import scienceSidebar from './scienceSidebar'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
// baseUrl = 'http://localhost:8001/'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
export default {
  components: {
    'science-sidebar': scienceSidebar,
    VueperSlides,
    VueperSlide
  },
  mixins: [AnalysisMixin],
  data () {
    return {
      baseUrl: 'https://frb.chimenet.ca/frb-master/',
      items: [],
      items1: [],
      fields1: [],
      items2: [],
      fields2: [],
      items3: [],
      fields3: [],
      showfields: [],
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage1: 1,
      perPage1: 5,
      // totalRows1: items1.length,
      currentPage2: 1,
      perPage2: 5,
      // totalRows2: items2.length,
      currentPage3: 1,
      perPage3: 5,
      // totalRows3: items3.length,
      pageOptions1: [ 5, 10, 15, 50, 100 ],
      pageOptions2: [ 5, 10, 15, 50, 100 ],
      pageOptions3: [ 5, 10, 15, 50, 100 ],
      sortBy: null,
      plot: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter1: null,
      filter2: null,
      filter3: null,
      modalInfo: { title: '', content: '' },
      headVariant: 'dark',
      variants: ['primary', 'secondary', 'danger', 'warning', 'success', 'info', 'dark'],
      tableVariant: 'danger',
      // In your component's data.
      slides: [
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_repeater_00_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_repeater_01_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_00_diagnostic_reduced.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_01_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_02_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_03_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_04_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_05_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_06_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_07_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_08_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_09_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_10_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_11_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_12_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_13_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_14_diagnostic.png'
        },
        {
          // You can also provide a URL for the image.
          image: 'https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=/data/chime/intensity/processed/catalog/catalog_plots/catalog_wfalls_oneoff_15_diagnostic.png'
        }
      ]
    }
  },
  mounted () {
    this.baseUrl = baseUrl
    // this.reloadWindow()
    // this.userName = localStorage.username
    // document.getElementById('welcome-catalog').innerHTML = 'Welcome @' + localStorage.username
    this.refreshToken()
    var url = 'https://frb.chimenet.ca/frb-master/catalog/1'
    var authHeaders = {'Authorization': localStorage.accessToken}
    this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
      .then(response => {
        this.parseResponse(response.body)
      }, response => {
      })
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.showfields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },
    nameState () {
      return this.knownsource.length > 7
    },
    catalogName () {
      var today = new Date()
      var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      return 'catalog-' + date + '.json'
    },
    downloadData () {
      var contentType = 'application/json'
      var dData = JSON.stringify(this.items, null, 2)
      var blob = new Blob([dData], {type: contentType})
      var url = window.URL.createObjectURL(blob)
      return url
    },
    totalRows1 () {
      return this.items1.length
    },
    totalRows2 () {
      return this.items2.length
    },
    totalRows3 () {
      return this.items3.length
    }
  },
  methods: {
    parseResponse (events) {
      this.items = events['events']
      document.getElementById('candidate-heading').innerHTML = 'CHIME/FRB Internal Catalog V1:  ' + this.items.length + ' Events'
      // this.fields = []
      // Name  Repeater_of RA Dec  Exposure_UT Exposure_LT Detection_SNR gl  gb  Detection_DM  Fluence_threshold
      var field1s = {
        'tns_name': ['Name', false],
        'repeater_of': ['Repeater Of', false],
        'ra': ['RA', 2],
        'dec': ['Dec', 2],
        'exposure_lower_limit': ['Exposure LT', 1],
        'exposure_upper_limit': ['Exposure UT', 1],
        'bonsai_snr': ['Detection SNR', 1],
        'bonsai_dm': ['Detection DM', 1],
        'gl': ['gl', 1],
        'gb': ['gb', 1],
        'fluence_threshold_upper_68': ['Fluence threshold Upper 1sigma', false],
        'fluence_threshold_upper_95': ['Fluence threshold Upper 2sigma', false],
        'fluence_threshold_lower_68': ['Fluence threshold Lower 1sigma', false],
        'fluence_threshold_lower_95': ['Fluence threshold Lower 2sigma', false]
      }
      var field1keys = Object.keys(field1s)
      this.fields1 = []
      for (var i = 0; i < field1keys.length; i++) {
        this.fields1.push({key: field1keys[i], label: field1s[field1keys[i]][0], sortable: true, 'class': 'text-center'})
      }
      this.items1 = []
      var item = {}
      for (i = 0; i < events['events'].length; i++) {
        // item['_rowVariant'] = 'dark'
        for (var k = 0; k < field1keys.length; k++) {
          if (field1s[field1keys[k]][1] !== false) {
            item[field1keys[k]] = events['events'][i][field1keys[k]].toFixed(field1s[field1keys[k]][1])
          } else {
            item[field1keys[k]] = events['events'][i][field1keys[k]]
          }
        }
        this.items1.push(item)
        item = {}
      }
      var field2s = {
        // [field, toFixed(num), include for all, is list]
        'tns_name': ['Name', false, true, false],
        'dm_excess_ne2001': ['DM Excess (NE2001)', 1, false, false],
        'dm_excess_ymw16': ['DM Excess (YMW16)', 1, false, false],
        'fitburst_snr': ['SNR', 1, false, false],
        'fitburst_dm': ['DM', 2, false, false],
        'box_car_width': ['Box Car Width', 5, false, false],
        'scattering_time_ms': ['Scattering Time', false, false, false],
        'flux': ['Flux', 1, false, false],
        'fluence': ['Fluence', 1, false, false],
        'sub_burst_id': ['Sub Burst ID', false, true, false],
        'toas_inf': ['TOA @inf', false, true, true],
        'toas': ['TOA @400.19 MHz', false, true, true],
        'pulse_width_ms': ['Pulse Width (ms)', false, true, true],
        'spectral_index': ['Spectral Index', 2, true, true],
        'spectral_running': ['Spectral Running', 2, true, true],
        'bandwidth_high': ['Bandwidth (Top)', 1, true, true],
        'bandwidth_low': ['Bandwidth (Bottom)', 1, true, true],
        'peak_frequency': ['Peak Frequency', 1, true, true]
      }
      var field2keys = Object.keys(field2s)
      this.fields2 = []
      for (i = 0; i < field2keys.length; i++) {
        this.fields2.push({key: field2keys[i], label: field2s[field2keys[i]][0], sortable: true, 'class': 'text-center'})
      }
      this.items2 = []
      item = {}
      var evt = null
      for (i = 0; i < events['events'].length; i++) {
        evt = events['events'][i]
        for (var s = 0; s < evt['toas'].length; s++) {
          // item['_rowVariant'] = 'dark'
          evt['sub_burst_id'] = s
          for (k = 0; k < field2keys.length; k++) {
            if (field2s[field2keys[k]][1] !== false) {
              if (field2s[field2keys[k]][3] === true) {
                item[field2keys[k]] = evt[field2keys[k]][s].toFixed(field2s[field2keys[k]][1])
              } else {
                if (s === 0 || ['tns_name', 'sub_burst_id'].includes(field2keys[k])) {
                  item[field2keys[k]] = evt[field2keys[k]].toFixed(field2s[field2keys[k]][1])
                }
              }
            } else {
              if (field2s[field2keys[k]][3] === true) {
                item[field2keys[k]] = evt[field2keys[k]][s]
              } else {
                if (s === 0 || ['tns_name', 'sub_burst_id'].includes(field2keys[k])) {
                  item[field2keys[k]] = evt[field2keys[k]]
                }
              }
            }
          }
          this.items2.push(item)
          item = {}
        }
      }
      this.items3 = []
      var field3s = {
        // [field, toFixed(num), include for all, is list]
        'old_name': ['Old Name'],
        'tns_name': ['TNS Name']
      }
      var field3keys = Object.keys(field3s)
      this.fields3 = []
      for (i = 0; i < field3keys.length; i++) {
        this.fields3.push({key: field3keys[i], label: field3s[field3keys[i]][0], sortable: true, 'class': 'text-center'})
      }
      item = {}
      for (i = 0; i < events['events'].length; i++) {
        // item['_rowVariant'] = 'dark'
        if (events['events'][i]['old_name'] !== '') {
          item['old_name'] = events['events'][i]['old_name']
          item['tns_name'] = events['events'][i]['tns_name']
          this.items3.push(item)
          item = {}
        }
      }
    },
    onFiltered1 (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length
      this.currentPage1 = 1
    },
    onFiltered2 (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows2 = filteredItems.length
      this.currentPage2 = 1
    },
    onFiltered3 (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows3 = filteredItems.length
      this.currentPage3 = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Science/science_catalog.vue